var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNumerationFile,
              expression: "isNumerationFile"
            }
          ],
          staticClass: "col-md-6"
        },
        [
          _c("list-subject-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "copySubjectType",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              label: "Distribución",
              name: "copySubjectType",
              danger: _vm.errors.has(_vm.scope + ".copySubjectType"),
              "danger-text": _vm.errors.first(_vm.scope + ".copySubjectType"),
              "is-doc-digital": _vm.isDocDigital
            },
            model: {
              value: _vm.copySubjectForm.copySubjectType,
              callback: function($$v) {
                _vm.$set(_vm.copySubjectForm, "copySubjectType", $$v)
              },
              expression: "copySubjectForm.copySubjectType"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNumerationFile,
              expression: "isNumerationFile"
            }
          ],
          staticClass: "col-md-6"
        },
        [
          _vm.copySubjectForm.copySubjectType === "sanitarias"
            ? _c("ListSanitaryCompanies", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        _vm.copySubjectForm.copySubjectType === "sanitarias",
                      max: "200"
                    },
                    expression:
                      "{\n          required: copySubjectForm.copySubjectType === 'sanitarias',\n          max: '200'\n        }"
                  }
                ],
                ref: "copySubject",
                attrs: {
                  "with-email": "",
                  autocomplete: "off",
                  "data-vv-as": "empresa sanitaria",
                  name: "copySubject",
                  isClearable: true,
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.copySubjectForm.copySubjectType) &&
          _vm.copySubjectForm.copySubjectType === "oficinas"
            ? _c("list-offices", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(
                          _vm.copySubjectForm.copySubjectType
                        ) && _vm.copySubjectForm.copySubjectType === "oficinas"
                    },
                    expression:
                      "{ required:  !isInput.includes(copySubjectForm.copySubjectType)\n              && copySubjectForm.copySubjectType === 'oficinas' }"
                  }
                ],
                ref: "copySubject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Oficina",
                  name: "copySubject",
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.copySubjectForm.copySubjectType) &&
          _vm.copySubjectForm.copySubjectType === "unidades"
            ? _c("list-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(
                          _vm.copySubjectForm.copySubjectType
                        ) && _vm.copySubjectForm.copySubjectType === "unidades"
                    },
                    expression:
                      "{ required:  !isInput.includes(copySubjectForm.copySubjectType)\n              && copySubjectForm.copySubjectType === 'unidades' }"
                  }
                ],
                ref: "copySubject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Unidad",
                  name: "copySubject",
                  typeList: 1,
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.copySubjectForm.copySubjectType) &&
          _vm.copySubjectForm.copySubjectType !== "usuarios" &&
          _vm.copySubjectForm.copySubjectType !== "oficinas" &&
          _vm.copySubjectForm.copySubjectType !== "unidades" &&
          _vm.copySubjectForm.copySubjectType !== "sanitarias"
            ? _c("list-subjects", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(
                          _vm.copySubjectForm.copySubjectType
                        ) && _vm.copySubjectForm.copySubjectType !== "usuarios"
                    },
                    expression:
                      "{\n            required: !isInput.includes(copySubjectForm.copySubjectType)\n              && copySubjectForm.copySubjectType !== 'usuarios'\n          }"
                  }
                ],
                ref: "copySubject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "copySubject",
                  "parent-value": _vm.copySubjectForm.copySubjectType,
                  disabled: !_vm.copySubjectForm.copySubjectType,
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.copySubjectForm.copySubjectType) &&
          _vm.copySubjectForm.copySubjectType === "usuarios"
            ? _c("list-user", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(
                          _vm.copySubjectForm.copySubjectType
                        ) && _vm.copySubjectForm.copySubjectType === "usuarios"
                    },
                    expression:
                      "{\n            required: !isInput.includes(copySubjectForm.copySubjectType)\n              && copySubjectForm.copySubjectType === 'usuarios'\n          }"
                  }
                ],
                ref: "copySubject",
                staticClass: "w-100",
                attrs: {
                  withFilters: "",
                  rolId: "7441a75e-80b9-486a-8595-34c487a56dd9",
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "subject",
                  disabled: !_vm.copySubjectForm.copySubjectType,
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e(),
          _vm.isInput.includes(_vm.copySubjectForm.copySubjectType)
            ? _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.isInput.includes(
                        _vm.copySubjectForm.copySubjectType
                      )
                    },
                    expression:
                      "{ required: isInput.includes(copySubjectForm.copySubjectType) }"
                  }
                ],
                key: "subject-input",
                staticClass: "w-100",
                attrs: {
                  label: "Ingrese un nombre",
                  name: "subject",
                  danger: _vm.errors.has(_vm.scope + ".copySubject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
                },
                model: {
                  value: _vm.copySubjectForm.copySubject,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
                  },
                  expression: "copySubjectForm.copySubject"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isNumerationFile,
              expression: "!isNumerationFile"
            }
          ],
          staticClass: "col-md-12"
        },
        [
          _c("list-user", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "copySubject",
            staticClass: "w-100",
            attrs: {
              withFilters: "",
              rolId: "7441a75e-80b9-486a-8595-34c487a56dd9",
              autocomplete: "",
              label: "Lista de Destino",
              name: "subject",
              disabled: !_vm.copySubjectForm.copySubjectType,
              danger: _vm.errors.has(_vm.scope + ".copySubject"),
              "danger-text": _vm.errors.first(_vm.scope + ".copySubject")
            },
            model: {
              value: _vm.copySubjectForm.copySubject,
              callback: function($$v) {
                _vm.$set(_vm.copySubjectForm, "copySubject", $$v)
              },
              expression: "copySubjectForm.copySubject"
            }
          })
        ],
        1
      )
    ]),
    _vm.copySubjectForm.copySubjectType === "docDigital"
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("list-institutions-doc-digital", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        _vm.copySubjectForm.copySubjectType === "docDigital"
                    },
                    expression:
                      "{ required: copySubjectForm.copySubjectType === 'docDigital'}"
                  }
                ],
                ref: "copySubjectTypeDigitalDoc",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Instituciones DocDigital",
                  name: "subjectTypeDigitalDoc",
                  "parent-value": _vm.copySubjectForm.copySubject,
                  danger: _vm.errors.has(
                    _vm.scope + ".copySubjectTypeDigitalDoc"
                  ),
                  "danger-text": _vm.errors.first(
                    _vm.scope + ".copySubjectTypeDigitalDoc"
                  )
                },
                model: {
                  value: _vm.copySubjectForm.copySubjectTypeDigitalDoc,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.copySubjectForm,
                      "copySubjectTypeDigitalDoc",
                      $$v
                    )
                  },
                  expression: "copySubjectForm.copySubjectTypeDigitalDoc"
                }
              })
            ],
            1
          ),
          _vm.copySubjectForm.copySubjectType === "docDigital" &&
          _vm.copySubjectForm.copySubject !== "" &&
          _vm.copySubjectForm.copySubject !== undefined
            ? _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c(
                    "vs-checkbox",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            "Seleccionar todas las instituciones DocDigital",
                          expression:
                            "'Seleccionar todas las instituciones DocDigital'"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: {
                        color: "primary",
                        disabled: _vm.disabledSelectAll
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.selectDocDigitalCopy()
                        }
                      },
                      model: {
                        value: _vm.selectAllDocDigitalCopy,
                        callback: function($$v) {
                          _vm.selectAllDocDigitalCopy = $$v
                        },
                        expression: "selectAllDocDigitalCopy"
                      }
                    },
                    [_vm._v(" Seleccionar todas ")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm.emailRequired.includes(_vm.copySubjectForm.copySubjectType)
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.emailRequired.includes(
                        _vm.copySubjectForm.copySubjectType
                      ),
                      email: true
                    },
                    expression:
                      "{\n            required: emailRequired.includes(copySubjectForm.copySubjectType)\n            ,\n            email: true\n          }"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Correo Electrónico Persona Destinatario",
                  name: "copySubjectEmail",
                  danger: _vm.errors.has(_vm.scope + ".copySubjectEmail"),
                  "danger-text": _vm.errors.first(
                    _vm.scope + ".copySubjectEmail"
                  )
                },
                model: {
                  value: _vm.copySubjectForm.copySubjectEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "copySubjectEmail", $$v)
                  },
                  expression: "copySubjectForm.copySubjectEmail"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.copySubjectForm.copySubjectType === "usuarios"
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-select",
                {
                  staticClass: "w-100 con-select autocompletex",
                  attrs: {
                    autocomplete: "",
                    label: "Seleccione tipo de providencia",
                    "data-cy": "copy-providence"
                  },
                  model: {
                    value: _vm.copySubjectForm.providence,
                    callback: function($$v) {
                      _vm.$set(_vm.copySubjectForm, "providence", $$v)
                    },
                    expression: "copySubjectForm.providence"
                  }
                },
                [
                  _c("vs-select-item", {
                    attrs: {
                      value: _vm.providenceTypes.KNOWLEDGE,
                      text: "Conocimiento"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("label", [_vm._v("Fecha Vencimiento")]),
              _c("b-form-datepicker", {
                attrs: {
                  locale: "es",
                  min: _vm.minDate,
                  placeholder: "Fecha vencimiento",
                  name: "providenceExpiration",
                  "label-help": "Puede usar las flechas del teclado y espacio"
                },
                model: {
                  value: _vm.copySubjectForm.providenceExpiration,
                  callback: function($$v) {
                    _vm.$set(_vm.copySubjectForm, "providenceExpiration", $$v)
                  },
                  expression: "copySubjectForm.providenceExpiration"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12 d-flex align-items-end justify-content-end" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { "data-cy": "add-copy-button", variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.addCopy()
                }
              }
            },
            [_vm._v(" Agregar copia a ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }